import { NUMBER  } from "../../constants/app-constants";

const VALID_MOBILE_NUMBER_DIGITS = [NUMBER.SIX, NUMBER.SEVEN, NUMBER.EIGHT, NUMBER.NINE];

export default (mobile) => {
    return VALID_MOBILE_NUMBER_DIGITS.includes(parseInt(mobile[0])) && mobile.length === NUMBER.TEN;
};
